import { TeamCaptain } from "../pages/Opportunities/types";

export const soccerCaptain: TeamCaptain = {
  name: "Henrique Pedras",
  phone: "+1 (703) 509-0553",
  email: "henriquepedras38@gmail.com",
  instagram: "https://www.instagram.com/riquepedras/",
  image: "/soccerCaptain.jpeg",
  instagramUser: "@riquepedras",
};
export const volleyballCaptain: TeamCaptain = {
  name: "Paulo Maia",
  phone: "+55 86 8802-7909",
  email: "paulo.cortellazzi@mail.utoronto.ca", // change this to paulao email
  instagram: "https://www.instagram.com/paulomaiacortellazzi/",
  image: "/volleyballCaptain.jpeg",
  instagramUser: "@paulomaiacortellazzi",
};
